import styled, { createGlobalStyle } from 'styled-components';

export const LayoutDashboardLeftMenuCustomersStyle = {
  Container: styled.div`
    position: relative;
    .left-menu-customers-button {
      position: absolute;
    }
  `,
  Global: createGlobalStyle`
    .left-menu-customers-dropdown-panel {
      margin-top: 44px;
      transform: translateX(calc(42px));
      min-width: 260px !important;
      &.is-open {
        transform: translateX(calc(220px));
      }
    }
  `,
};
